import React from 'react';
import { StarIcon } from 'lucide-react';
const QUOTES = [{
  quote: 'I used to spend hours adapting materials for different students. Now I choose the right resource, adjust the support level, and I’m ready to teach.',
  name: 'Sarah M.',
  location: 'London, UK'
}, {
  quote: 'The visual resources helped me bring much more structure into everyday routines. I can prepare supports without creating everything from zero.',
  name: 'Emma W.',
  location: 'Sydney, Australia'
}, {
  quote: 'I had activities, templates, and visual supports scattered everywhere. Now I have one organized system that I can adapt throughout the week.',
  name: 'Laura T.',
  location: 'Toronto, Canada'
}];
export function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} aria-label="5 out of 5 stars" data-id="element-190" data-mp="2kzi0rza67t4g">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-mustard text-mustard" aria-hidden="true" data-id="element-191" data-mp="2c16eg9gc7hht" />)}
    </div>;
}
export function SampleNote({
  className = ''
}: {
  className?: string;
}) {
  return <p className={`text-center text-[9px] font-semibold uppercase tracking-widest text-muted/70 ${className}`} data-id="element-192" data-mp="2pqjvggnhzu9j">
      Sample testimonial — replace with verified customer
    </p>;
}
export function QuickTestimonials() {
  return <section aria-label="Teacher quotes" className="w-full bg-cream px-3 py-6 sm:px-5" data-id="element-193" data-mp="2tpso1i6sxm3i">
      <div className="mx-auto max-w-5xl" data-id="element-194" data-mp="260gg0ln7nk2s">
        <SampleNote className="mb-2" data-id="element-195" data-mp="261j7auog3oj8" />
        <div className="grid gap-2 md:grid-cols-3" data-id="element-196" data-mp="25ydeb4cp42i8">
          {QUOTES.map(item => <figure key={item.name} className="flex flex-col rounded-xl border border-ink/10 bg-white p-3" data-id="element-197" data-mp="220za5r3vgkx3">
              <Stars data-id="element-198" data-mp="2fsm77t5n1xgx" />
              <blockquote className="mt-1.5 text-[13px] leading-snug text-body" data-id="element-199" data-mp="2azt419ptix6y">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-2 text-[11px] font-bold uppercase tracking-wide text-ink" data-id="element-200" data-mp="1n96vlhbwjawf">
                {item.name}
                <span className="ml-1 font-medium normal-case tracking-normal text-muted" data-id="element-201" data-mp="1i92oghwvvsiv">
                  {item.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}